import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  mapTagIdsToTags(tagIds: string[], attributes: any[]): any[] {
    const allTags: any[] = [];

    attributes?.forEach((attribute) => {
      if (attribute?.tags?.length) {
        allTags.push(...attribute.tags);
      } else {
        allTags.push(attribute);
      }
    });

    return allTags.filter((tag) => tagIds.includes(tag.tagId));
  }
}
